import type { TOC } from '@ember/component/template-only';
import { eq } from 'ember-truth-helpers';
import HotelBenchmarkInsightCompetitorsCompetitorsList from 'lumen/components/hotel/benchmark-insight/competitors/competitors-list';
import HotelBenchmarkInsightCompetitorsSmartCompsetTabSmartCompset from 'lumen/components/hotel/benchmark-insight/competitors/smart-compset/tab-smart-compset';
import type {
  BenchmarkInsightCompetitorsCompetitor,
  BeniSmartCompset,
} from 'lumen/models';
import {
  BENI_COMPETITORS_TABS,
  type CompetitorsBenchmarkTab,
} from 'lumen/utils/constants/benchmark-insight/beni-constant-values';

interface HotelBenchmarkInsightCompetitorsCompetitorsListContainerSignature {
  Args: {
    activeTab: CompetitorsBenchmarkTab;
    compset: BenchmarkInsightCompetitorsCompetitor[];
    isLoading: boolean;
    smartCompset: BeniSmartCompset | null;
  };
}

const HotelBenchmarkInsightCompetitorsCompetitorsListContainer: TOC<HotelBenchmarkInsightCompetitorsCompetitorsListContainerSignature> =
  <template>
    {{#if (eq @activeTab BENI_COMPETITORS_TABS.SMART_COMPSET)}}
      <HotelBenchmarkInsightCompetitorsSmartCompsetTabSmartCompset
        @isLoading={{@isLoading}}
        @smartCompset={{@smartCompset}}
      />
    {{else}}
      <HotelBenchmarkInsightCompetitorsCompetitorsList
        @compset={{@compset}}
        @isLoading={{@isLoading}}
      />
    {{/if}}
  </template>;

export default HotelBenchmarkInsightCompetitorsCompetitorsListContainer;
